import React from 'react';
import { useParams } from 'react-router-dom';
import PublicLayout from './layouts/PublicLayout.tsx';
import PublicWaitlist from './pages/public/PublicWaitlist.tsx';

const PublicWaitlistWrapper: React.FC = () => {
  const { slug_restaurante } = useParams<{ slug_restaurante: string }>();

  return (
    <PublicLayout title="Fila de Espera">
      <PublicWaitlist slug={slug_restaurante} />
    </PublicLayout>
  );
};

export default PublicWaitlistWrapper;
